import { SelectData } from "../../models";

export enum WorkflowOrganisationAccessLevel {
  Owner = "Owner",
  Author = "Author",
  Contributor = "Contributor",
  User = "User",
  Viewer = "Viewer",
}

export const WorkflowOrganisationAccessLevelsSelectData = [
  { key: WorkflowOrganisationAccessLevel.Owner, value: WorkflowOrganisationAccessLevel.Owner },
  { key: WorkflowOrganisationAccessLevel.Author, value: WorkflowOrganisationAccessLevel.Author },
  { key: WorkflowOrganisationAccessLevel.Contributor, value: WorkflowOrganisationAccessLevel.Contributor },
  { key: WorkflowOrganisationAccessLevel.User, value: WorkflowOrganisationAccessLevel.User },
  { key: WorkflowOrganisationAccessLevel.Viewer, value: WorkflowOrganisationAccessLevel.Viewer },
  { key: "No access", value: "No access" },
] as SelectData;
